<template>
  <div class="navbar-mobile" :class="{ 'navbar-mobile--ios': view?.isIOS }">
    <AppMenu :view="view" />
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, Raw, ref } from 'vue'

import { HeaderView } from '@/models/header'

import AppMenu from '@/app/components/header/AppMenu.vue'

const view = ref<Raw<HeaderView>>(new HeaderView())

onBeforeMount(async () => {
  await view.value.init()
})
</script>

<style lang="scss" scoped>
.navbar-mobile {
  position: sticky;
  z-index: 5;
  left: 0;
  bottom: 0;
  background-color: $c-white;
  border-top: 1px solid $c-border;
  padding: 6px 28px 13px 6px;

  @media only screen and (max-width: $w-medium-s) {
    padding: 6px 13px 13px 13px;
  }

  @media only screen and (min-width: $w-tablet-b) {
    display: none;
  }
}

.navbar-mobile--ios {
  @supports (padding-bottom: env(safe-area-inset-top)) {
    padding-bottom: env(safe-area-inset-bottom);
  }
}

.night-mode .navbar-mobile {
  background-color: $c-dark-2;
  border-color: $c-dark-5;
}
</style>
